import React, { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { TariffUsagesPanel } from './TariffUsagesPanel'

export const CannotDeleteTariffModal: React.FC<{
    tariffCuid: string
    activeUsageCount: number
    onClose: () => void
}> = ({ tariffCuid, activeUsageCount, onClose }) => (
    <Transition show as={Fragment}>
        <Dialog className="relative z-50" onClose={onClose}>
            <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <Dialog.Panel className="relative w-full transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all dark:bg-slate-900 sm:my-8 sm:max-w-3xl sm:p-6">
                            <div>
                                <div className="flex items-center gap-4">
                                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-red-100 dark:bg-red-900">
                                        <ExclamationTriangleIcon
                                            className="h-6 w-6 text-red-600 dark:text-red-400"
                                            aria-hidden="true"
                                        />
                                    </div>
                                    <Dialog.Title className="text-lg font-medium leading-6 text-slate-900 dark:text-slate-100">
                                        Can't delete this tariff
                                    </Dialog.Title>
                                </div>
                                <div className="mt-3 min-w-0 sm:ml-14">
                                    <p className="text-sm text-slate-500 dark:text-slate-400">
                                        You must remove all meter service usages before you can delete
                                        this tariff.
                                    </p>
                                    <div className="mt-4 max-h-[60vh] overflow-auto text-left">
                                        <TariffUsagesPanel
                                            tariffCuid={tariffCuid}
                                            activeUsageCount={activeUsageCount}
                                            embedded
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                                <button
                                    type="button"
                                    className="inline-flex w-full justify-center rounded-md border border-slate-300 bg-white px-4 py-2 text-base font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:bg-slate-700 sm:w-auto sm:text-sm"
                                    onClick={onClose}
                                >
                                    Close
                                </button>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </div>
        </Dialog>
    </Transition>
)

export default CannotDeleteTariffModal
